import { render, staticRenderFns } from "./communicationLogDialog.vue?vue&type=template&id=1ffc0110&scoped=true&"
import script from "./communicationLogDialog.vue?vue&type=script&lang=js&"
export * from "./communicationLogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc0110",
  null
  
)

export default component.exports